// extracted by mini-css-extract-plugin
export default {"dialogmainwrapper":"dialogmodal_dialogmainwrapper__X-q5y","btns":"dialogmodal_btns__Yl9O0"};